<script>
import ArchiveBase from "@/components/base_components/ArchiveBase";
import ProjectService from "@/store/services/project.service";

export default {
    name: "ProjectArchive",
    extends: ArchiveBase,
    methods: {
        extendable() {
            let vm = this;

            this.swapState();

            ProjectService.update(this.item.id, this.item).then(function(response) {
                vm.$emit("swap", response.data);
            });
        },
        initialize() { // override to use the correct parameter "is_archive" instead of "archived"
            this.item = this.$props.data_object;
            this.is_archived = this.$props.data_object.is_archived;
        },
        swapState() { // override to use the correct parameter "is_archive" instead of "archived"
            this.is_archived = !this.is_archived;
            this.item.is_archived = this.is_archived;
        }
    }
}
</script>
